import React, {Component} from 'react';
import './NewScenePopup.css'
import {Button, Modal, Form, TextArea, Icon, Image, TransitionablePortal} from 'semantic-ui-react'
import {connect} from "react-redux";
import {createScene} from "../../../../../../redux/actions/index";
import SceneForm from '../../../../forms/scene-form/SceneForm'
import Popup from '../../../../common/popup/Popup'

class NewScenePopup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showPopup: false
    }
  }

  onSubmit = (scene) => {
    this.props.createScene(scene, this.props.currentCollection).then(() => {
      this.setState({
        ...this.state,
        showPopup: false
      });
    });
  }

  handleOpen = () => {
    this.setState({ showPopup: true })
  }

  handleClose = () => {
    this.setState({ showPopup: false });
  }

  renderTriggerButton = () => {
    return <Button fluid icon labelPosition='left' onClick={this.handleOpen}><Icon name='add'/><div className="centred-button-text">New Scene</div></Button>
  }

  renderContent = () => {
    return <span>
      <SceneForm scene={this.props.scene} onSubmit={this.onSubmit}/>
    </span>
  }

  renderActions = () => {
    return <span>
      <span className="action-button-container">
        <Button icon labelPosition='left' onClick={this.handleClose}><Icon name='cancel'/>Cancel</Button>
        </span>
        <span className="action-button-container">
        <Button icon labelPosition='left' type="submit" form="scene-form"><Icon name='add'/>Create</Button>
        </span>
      </span>
  }

  render() {
    return (
      <Popup
        width={800}
        height={435}
        showPopup={this.state.showPopup}
        header="New Scene"
        renderTriggerButton={this.renderTriggerButton}
        renderContent={this.renderContent}
        renderActions={this.renderActions}>
      </Popup>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createScene: (scene, collectionID) => dispatch(createScene(scene, collectionID))
  }
}

const mapStateToProps = state => {
  return {
    currentCollection: state.currentCollection
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewScenePopup)
